/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { DebugSendCompletionEmailOptions, DebugSendCompletionEmailStatus200, DebugSendCompletionEmailStatus422 } from '../models/DebugSendCompletionEmail'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { debugSendCompletionEmail } from '../clients/axios/debugSendCompletionEmail'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const debugSendCompletionEmailMutationKey = () => [{ url: '/admin/debug/send-completion-email' }] as const

export function debugSendCompletionEmailMutationOptions<TContext = unknown>(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const mutationKey = debugSendCompletionEmailMutationKey()
  return mutationOptions<DebugSendCompletionEmailStatus200, ResponseErrorConfig<DebugSendCompletionEmailStatus422>, DebugSendCompletionEmailOptions, TContext>({
    mutationKey,
    mutationFn: async({ body }) => {
      return await debugSendCompletionEmail({ ...config, body, throwOnError: true })
    },
  })
}

/**
 * @description Queue a course completion certificate email for a given user and course.
 * @summary Send Completion Email
 * {@link /admin/debug/send-completion-email}
 */
export function useDebugSendCompletionEmail<TContext>(options: {
  mutation?: UseMutationOptions<DebugSendCompletionEmailStatus200, ResponseErrorConfig<DebugSendCompletionEmailStatus422>, DebugSendCompletionEmailOptions, TContext> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>,
} = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? debugSendCompletionEmailMutationKey()

  const baseOptions = debugSendCompletionEmailMutationOptions(config) as UseMutationOptions<DebugSendCompletionEmailStatus200, ResponseErrorConfig<DebugSendCompletionEmailStatus422>, DebugSendCompletionEmailOptions, TContext>

  return useMutation<DebugSendCompletionEmailStatus200, ResponseErrorConfig<DebugSendCompletionEmailStatus422>, DebugSendCompletionEmailOptions, TContext>({
    ...baseOptions,
    mutationKey,
    ...mutationOptions,
  }, queryClient) as UseMutationResult<DebugSendCompletionEmailStatus200, ResponseErrorConfig<DebugSendCompletionEmailStatus422>, DebugSendCompletionEmailOptions, TContext>
}
